import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const ServiceSection = ({ id }) => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Services/GetServicesDetailsByDisplayedIniD?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedServices = response.map((service) => ({
          ...service,
          image: `${ImageURL}${service.imagePath}`,
        }));
        setServices(mappedServices);
      } else {
        setServices([]);
      }
    } catch (error) {
      setServices([]);
      console.error("Error fetching services:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedService(null);
    setIsModalOpen(false);
  };

  if (!services || services.length === 0) {
    return null;
  }

  return (
    <>
      <section className="wpo-Service-section-s3 section-padding" id="Service">
        <div className="container">
          <div className="wpo-Service-wrap service">
            <div className="container">
              <div className="row">
                <div className="wpo-section-title">
                  <h4>Services Meridian Offer</h4>
                  <div className="shape-2 wow fadeInUp custom-animation">
                    <img src="/assets/images/Wedding/shape6.png" alt="Shape" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" service-images">
                  {services.map((service, index) => (
                    <div
                      className="col-lg-3 col-md-3 col-sm-6 col-12"
                      key={index}
                      onClick={() => openModal(service)}
                    >
                      <div className="wpo-Service-item services wow fadeInUp">
                        <div className="wpo-Service-img services">
                          <img
                            src={service.image}
                            alt={service.serviceType}
                            style={{
                              width: "250px",
                              height: "200px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>
                        <div
                          className="wpo-Service-text"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          <a
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              lineHeight: "normal",
                              overflow: "hidden",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            title={service.serviceType}
                          >
                            {/* {service.serviceType.length > 16
                              ? `${service.serviceType.slice(0, 16)}...`
                              : service.serviceType} */}
                            {service.serviceType}
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && selectedService && (
        <div id="ServiceModal" className="popup">
          <div className="modal-content service">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedService.serviceType}</div>
            <div className="additional-text">
              <p>{selectedService.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceSection;
